<div class="d-flex justify-content-center align-items-center">
  <p-selectButton
    [allowEmpty]="false"
    class="selectButton_recipient_tab"
    [options]="justifyOptions"
    [(ngModel)]="valueJustifyOption"
    optionLabel="icon"
    style="font-size: 18px">
    <ng-template let-item pTemplate>
      <i [class]="item.icon"></i>
    </ng-template>
  </p-selectButton>
</div>
<div style="overflow: auto; height: calc(100vh - 300px); margin-right: -10px; padding-right: 10px">
  @if (valueJustifyOption?.state ==='list') {
  <section>
    <div class="pourActionTitle mb-4">
      {{ 'tracking.forAction' | translate }} @if (rightMail?.distribution?.addUser) {
      <i
        class="bi bi-plus-circle-fill greenIcon cursor--pointer mb-2"
        (click)="createAction()"
        [pTooltip]="'courrierFiche.requestAction' | translate"></i>
      }
    </div>
    @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @for (action of listOfActions; track action) {
    <app-action-card [action]="action" [mode]="'fromMail'" (emitAnswerToAction)="answerToAction($event)"></app-action-card>
    } @if (amountOfActions.length === 0 && !loadingDisplay) {
    <div class="alert alert-info">{{'tracking.noTrackingForThisCategory'|translate}}</div>
    }
    <div class="pourActionTitle mb-4">
      {{ 'tracking.forInfo' | translate }} @if (rightMail?.distribution?.addUser) {
      <i
        class="bi bi-plus-circle-fill greenIcon cursor--pointer mb-2"
        (click)="transfer()"
        [pTooltip]="'courrier.sendForInformation' | translate"></i>
      }
    </div>
    @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @if (loadingDisplay) {
    <p-skeleton width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    } @for (action of items|filterByPropertyIsNull: 'action'; track action) {
    <div class="action mb-3">
      <div id="divForBorder" class="action__toDo">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex">
            <div class="d-flex align-items-center me-4 my-3">
              <!-- suivi interne -->
              @if ((action.type ==='SERVICE')||(action.type ==='GROUPE')|| (action.type==='DESTINATAIRE' && action.user)) {
              <svg
                class="ms-4 me-4"
                width="19.7913715px"
                height="19.7982287px"
                viewBox="0 0 19.7913715 19.7982287"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Medium-Copy-7" transform="translate(-547.000000, -525.201771)">
                    <g id="noun-external-3776998-copy" transform="translate(547.000000, 525.201771)">
                      <polyline
                        id="Path-6"
                        stroke="#4A4A4A"
                        stroke-width="2.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        points="7.17249176 6.29822869 7.17249176 12.5795185 13.5 12.5795185"></polyline>
                      <line
                        x1="7.17249176"
                        y1="12.5795185"
                        x2="19.7913715"
                        y2="1.59931629e-17"
                        id="Path-7"
                        stroke="#4A4A4A"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"></line>
                      <path
                        d="M17.7936508,8.68589657 C17.1440781,8.68589657 16.610542,9.21943268 16.610542,9.86900533 L16.610542,14.6248051 C16.610542,16.155982 15.3578776,17.3855303 13.8498168,17.3855303 L5.15018315,17.3855303 C3.61900619,17.3855303 2.38945796,16.1328659 2.38945796,14.6248051 L2.38945796,5.92517139 C2.38945796,4.39399443 3.64212236,3.1644462 5.15018315,3.1644462 L9.90598291,3.1644462 C10.5555556,3.1644462 11.0890917,2.63091009 11.0890917,1.98133744 C11.0890917,1.33176479 10.5555556,0.798228687 9.90598291,0.798228687 L5.15018315,0.798228687 C2.31990232,0.798228687 0,3.09497341 0,5.94841184 L0,14.6480455 C0,17.4783264 2.29674472,19.7982287 5.15018315,19.7982287 L13.8498168,19.7982287 C16.6800977,19.7982287 19,17.501484 19,14.6480455 L19,9.86904676 C18.9766974,9.21947411 18.443182,8.68581372 17.7936094,8.68581372 L17.7936508,8.68589657 Z"
                        id="Path"
                        fill="#4A4A4A"
                        fill-rule="nonzero"></path>
                    </g>
                  </g>
                </g>
              </svg>
              }
              <!-- suivi externe -->
              @if ((action.type ==='DESTINATAIRE' && action.libre) || (action.type==='DESTINATAIRE' && !action.user)) {
              <svg
                class="ms-4 me-4"
                width="21px"
                height="21px"
                viewBox="0 0 21 21"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Medium-Copy-7" transform="translate(-547.000000, -590.000000)" fill="#4A4A4A" fill-rule="nonzero">
                    <g id="noun-external-3776998" transform="translate(547.000000, 590.000000)">
                      <path
                        d="M19.8530005,0 L13.3762589,0 C12.7465757,0 12.2293761,0.517200797 12.2293761,1.14688544 C12.2293761,1.77657008 12.7465757,2.29377088 13.3762589,2.29377088 L17.0644034,2.29392774 L6.33730017,13.0435441 C5.88756661,13.4932787 5.88756661,14.2129986 6.33730017,14.6627332 C6.56225129,14.8876848 6.85449979,15 7.14689287,15 C7.43928595,15 7.73155855,14.8875242 7.95648557,14.6627332 L18.7060775,3.93560555 L18.7060775,7.62375845 C18.7060775,8.25344309 19.2232771,8.77064389 19.8529603,8.77064389 C20.4826435,8.77064389 20.9998431,8.25344309 20.9998431,7.62375845 L21,1.14700214 C21,0.517317498 20.4828004,0 19.8531172,0 L19.8530005,0 Z"
                        id="Path"></path>
                      <path
                        d="M17.7936508,9.88766789 C17.1440781,9.88766789 16.610542,10.421204 16.610542,11.0707766 L16.610542,15.8265764 C16.610542,17.3577534 15.3578776,18.5873016 13.8498168,18.5873016 L5.15018315,18.5873016 C3.61900619,18.5873016 2.38945796,17.3346372 2.38945796,15.8265764 L2.38945796,7.1269427 C2.38945796,5.59576574 3.64212236,4.36621751 5.15018315,4.36621751 L9.90598291,4.36621751 C10.5555556,4.36621751 11.0890917,3.83268141 11.0890917,3.18310876 C11.0890917,2.53353611 10.5555556,2 9.90598291,2 L5.15018315,2 C2.31990232,2 0,4.29674472 0,7.15018315 L0,15.8498168 C0,18.6800977 2.29674472,21 5.15018315,21 L13.8498168,21 C16.6800977,21 19,18.7032553 19,15.8498168 L19,11.0708181 C18.9766974,10.4212454 18.443182,9.88758503 17.7936094,9.88758503 L17.7936508,9.88766789 Z"
                        id="Path"></path>
                    </g>
                  </g>
                </g>
              </svg>
              }
              <div>
                @if (action.transmissionUserName) {
                <span class="boldText">{{action.transmissionUserName}} </span>
                } <i class="bi bi-arrow-right"></i>
                @if (action.type ==='SERVICE') {
                <span class="boldText"> {{action.name}} ({{ 'tracking.service' | translate }})</span>
                } @if (action.type ==='GROUPE') {
                <span class="boldText"> {{action.name}} ({{ 'tracking.group' | translate }})</span>
                } @if (action.type === 'DESTINATAIRE') {
                <span class="boldText">
                  {{action.contactName ? action.contactName : action.libre}} @if (action.libre) {
                  <span class="boldText"> ({{ 'tracking.freeRecipient' | translate }})</span>
                  }
                </span>
                }
                <div>
                  @if (action.message) {
                  <span><i class="wordBreak">« {{action.message}}»</i></span>
                  }
                </div>
                <p class="mb-0">{{ 'action.transferredOnAlt' | translate }} {{action.transmisDate|momentFormat: 'DD/MM/YYYY'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @if (amountOfInfos.length === 0 && !loadingDisplay) {
    <div class="alert alert-info">{{'tracking.noTrackingForThisCategory'|translate}}</div>
    }
    <div class="mb-5"></div>
  </section>
  } @if (valueJustifyOption?.state ==='table') {
  <section>
    <i-table
      (onClickDelete)="deleteMultiple($event)"
      class="super-table"
      [columns]="columns "
      [items]="items"
      id="recipients-table"
      [height]="'60vh'"
      [multiselect]="true">
      @if (rightMail?.distribution?.addUser) {
      <div class="d-flex justify-content-end align-items-center">
        <i-button [text]="'courrier.requestAction' | translate" id="btnAddActionToMail" styleClass="green me-3" (click)="createAction()"></i-button>
        <i-button [text]="'courrier.sendForInformation'|translate" id="btnAddDestToMail" styleClass="green" (click)="transfer()"></i-button>
      </div>
      }
    </i-table>
  </section>
  }
</div>

<p-confirmDialog
  key="remplacantCourrierCreateRecipients"
  #cd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
